import { execute } from 'utils/API';
import { apiEndoints, httpMethods } from 'utils/constants';
import PropTypes from 'prop-types';

const listFiles = ({ queryKey }) => {
  const searchQuery = queryKey[2];
  const documentType = queryKey[3];
  const filters = queryKey[4] || {};
  const userToken = queryKey[5];

  return execute(
    httpMethods.GET,
    searchQuery === '' ? apiEndoints.LIST_FILES : apiEndoints.LIST_QUERIED_FILES,
    { authorization: userToken },
    {
      page: queryKey[1],
      kind: documentType,
      ...(searchQuery !== '' && { query: searchQuery }),
      ...(filters.startDate && { startDate: filters.startDate }),
      ...(filters.endDate && { endDate: filters.endDate }),
      ...(filters.status && { status: filters.status }),
      ...(filters.sortDirection && { sortDirection: filters.sortDirection }),
    },
    10,
  );
};

listFiles.propTypes = {
  queryKey: PropTypes.array.isRequired,
};

export { listFiles };
